export const environment = {
  production: true,
  apiUrl: 'https://yashaswipayslip-001-site4.mtempurl.com/api/'
  //apiUrl: 'https://localhost:44386/api/'
};

